import { createSelector } from 'reselect';
import _ from 'lodash';

const getUsers = state => state.search.members;

const getUserId = (state, id) => id;

export const getUserById = createSelector([getUsers, getUserId], (users, id) => _.find(users, ['_id', id]));



// WEBPACK FOOTER //
// ./app/selectors/search-selectors.js